import { getDefaultTabletDashboardLayout } from '@akin-home/dashboards';

import {
  useSubscribeToDashboards,
  useTabletDashboardForUser,
} from '@akin-home/dashboards/react';
import { useIsFocused } from '@react-navigation/native';
import { useEffect } from 'react';
import { BMCDailySurveyReminderProvider } from '../../bmc/components/SurveyReminderProvider';
import { sendBackgroundMessage } from '../../chat/functions';
import { useUpdateScreenChatContext } from '../../chat/hooks';
import { intent_labels } from '../../chat/intent_labels';
import { useStateStore } from '../../stores/useStateStore';
import { useCurrentUserID, useCurrentUsername } from '../../users';
import { DashboardScreenView } from './DashboardScreenView';

export const DashboardScreen = () => {
  const user_id = useCurrentUserID();
  const username = useCurrentUsername();
  const is_focused = useIsFocused();

  useSubscribeToDashboards({ username });

  const dashboard = useStateStore((state) => state.current_dashboard);
  const setDashboard = useStateStore((state) => state.setDashboard);

  const { data, isLoading } = useTabletDashboardForUser(user_id);
  useEffect(() => {
    if (isLoading) return;

    if (data) {
      setDashboard(data, false);
    } else {
      setDashboard(getDefaultTabletDashboardLayout(), true);
    }
  }, [data, isLoading, setDashboard]);

  useUpdateScreenChatContext();
  useEffect(() => {
    if (is_focused) {
      sendBackgroundMessage(intent_labels.open_dashboard);
    }
  }, [is_focused]);

  return (
    <BMCDailySurveyReminderProvider>
      <DashboardScreenView dashboard={dashboard} />
    </BMCDailySurveyReminderProvider>
  );
};
